module.exports = __webpack_public_path__ + "static/index/img/home-hotels.d17cbf70.jpg";